(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/draws/assets/javascripts/draws-api.js') >= 0) return;  svs.modules.push('/components/numbergames/draws/assets/javascripts/draws-api.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const drawsSingleton = svs.numbergames.draws.internal.getDrawsSingleton();
const {
  DRAW_STATES
} = svs.numbergames.draws.constants;
function clientNow() {
  return drawsSingleton.clientNow;
}
svs.numbergames.draws.drawsApi.clientNow = clientNow;
const firstPlayableDrawsApi = {
  firstPlayableDraw: draw => _objectSpread(_objectSpread({}, draw), draw.jokerDraw && {
    jokerDraw: _objectSpread({}, draw.jokerDraw)
  }),
  isDrawOpen: draw => (draw === null || draw === void 0 ? void 0 : draw.drawStateId) === DRAW_STATES.OPEN,
  drawNumber: draw => draw === null || draw === void 0 ? void 0 : draw.drawNumber,
  regOpenTime: draw => draw === null || draw === void 0 ? void 0 : draw.regOpenTime,
  regCloseTime: draw => draw === null || draw === void 0 ? void 0 : draw.regCloseTime,
  cancelCloseTime: draw => draw === null || draw === void 0 ? void 0 : draw.cancelCloseTime,
  wasOpenedToday: draw => draw && dateFns.isSameDay(clientNow(), new Date(draw.regOpenTime)),
  roomKeys: draw => draw === null || draw === void 0 ? void 0 : draw.roomKeys,
  isJokerDrawOpen: draw => {
    var _draw$jokerDraw;
    return (draw === null || draw === void 0 || (_draw$jokerDraw = draw.jokerDraw) === null || _draw$jokerDraw === void 0 ? void 0 : _draw$jokerDraw.drawStateId) === DRAW_STATES.OPEN;
  },
  hasPlayableJoker: draw => {
    var _draw$jokerDraw2;
    return (draw === null || draw === void 0 || (_draw$jokerDraw2 = draw.jokerDraw) === null || _draw$jokerDraw2 === void 0 ? void 0 : _draw$jokerDraw2.drawStateId) <= DRAW_STATES.OPEN;
  },
  jokerDrawNumber: draw => {
    var _draw$jokerDraw3;
    return draw === null || draw === void 0 || (_draw$jokerDraw3 = draw.jokerDraw) === null || _draw$jokerDraw3 === void 0 ? void 0 : _draw$jokerDraw3.drawNumber;
  },
  jokerRegOpenTime: draw => {
    var _draw$jokerDraw4;
    return draw === null || draw === void 0 || (_draw$jokerDraw4 = draw.jokerDraw) === null || _draw$jokerDraw4 === void 0 ? void 0 : _draw$jokerDraw4.regOpenTime;
  },
  jokerRegCloseTime: draw => {
    var _draw$jokerDraw5;
    return draw === null || draw === void 0 || (_draw$jokerDraw5 = draw.jokerDraw) === null || _draw$jokerDraw5 === void 0 ? void 0 : _draw$jokerDraw5.regCloseTime;
  }
};
const openDrawsApi = {
  currentOpenDraw: draw => _objectSpread(_objectSpread({}, draw), draw.jokerDraw && {
    jokerDraw: _objectSpread({}, draw.jokerDraw)
  }),
  currentDrawNumber: draw => draw === null || draw === void 0 ? void 0 : draw.drawNumber,
  currentRegOpenTime: draw => draw === null || draw === void 0 ? void 0 : draw.regOpenTime,
  currentRegCloseTime: draw => draw === null || draw === void 0 ? void 0 : draw.regCloseTime,
  currentCancelCloseTime: draw => draw === null || draw === void 0 ? void 0 : draw.cancelCloseTime
};
const nextDrawsApi = {
  nextDraw: draw => _objectSpread(_objectSpread({}, draw), draw.jokerDraw && {
    jokerDraw: _objectSpread({}, draw.jokerDraw)
  }),
  nextRegOpenTime: draw => draw === null || draw === void 0 ? void 0 : draw.regOpenTime,
  nextRegCloseTime: draw => draw === null || draw === void 0 ? void 0 : draw.regCloseTime
};
function formatDraws(draws, getValue, products) {
  draws = Object.values(draws).filter(Boolean);
  if (!Array.isArray(products) && draws.length <= 1) {
    return getValue(draws[0]);
  }
  return draws.reduce((acc, draw) => Object.assign(acc, {
    [draw.productItsId]: getValue(draw)
  }), {});
}
Object.entries(firstPlayableDrawsApi).forEach(_ref => {
  let [key, value] = _ref;
  svs.numbergames.draws.drawsApi[key] = products => formatDraws(drawsSingleton.findFirstPlayableDraw(products), value, products);
  svs.numbergames.draws.asyncDrawsApi[key] = async products => formatDraws(await drawsSingleton.getFirstPlayableDraw(products), value, products);
});
Object.entries(openDrawsApi).forEach(_ref2 => {
  let [key, value] = _ref2;
  svs.numbergames.draws.drawsApi[key] = products => formatDraws(drawsSingleton.findOpenDraw(products), value, products);
  svs.numbergames.draws.asyncDrawsApi[key] = async products => formatDraws(await drawsSingleton.getOpenDraw(products), value, products);
});
Object.entries(nextDrawsApi).forEach(_ref3 => {
  let [key, value] = _ref3;
  svs.numbergames.draws.drawsApi[key] = products => formatDraws(drawsSingleton.findNextDraw(products), value, products);
  svs.numbergames.draws.asyncDrawsApi[key] = async products => formatDraws(await drawsSingleton.getNextDraw(products), value, products);
});
const findDrawsApi = {
  findDraw: (drawOptions, draws) => {
    draws = draws.map(draw => _objectSpread(_objectSpread({}, draw), draw.jokerDraw && {
      jokerDraw: _objectSpread({}, draw.jokerDraw)
    }));
    if (!Array.isArray(drawOptions) && draws.length === 1) {
      return draws[0];
    }
    return draws;
  }
};

svs.numbergames.draws.drawsApi.findDraw = drawOptions => findDrawsApi.findDraw(drawOptions, drawsSingleton.findDraw(drawOptions));
svs.numbergames.draws.asyncDrawsApi.findDraw = async drawOptions => findDrawsApi.findDraw(drawOptions, await drawsSingleton.getDraw(drawOptions));
const jackpotApi = {
  jackpot: jackpot => _objectSpread({}, jackpot),
  jackpotAmount: jackpot => jackpot === null || jackpot === void 0 ? void 0 : jackpot.jackpotAmount,
  jackpotAmountString: jackpot => jackpot === null || jackpot === void 0 ? void 0 : jackpot.jackpotAmountString,
  jackpotAmountStringShort: jackpot => jackpot === null || jackpot === void 0 ? void 0 : jackpot.jackpotAmountStringShort,
  isDefaultJackpot: jackpot => jackpot === null || jackpot === void 0 ? void 0 : jackpot.defaultJackpot
};
function formatJackpots(jackpots, getValue, products) {
  jackpots = Object.entries(jackpots);
  if (!Array.isArray(products) && jackpots.length <= 1) {
    const [, jackpot] = jackpots[0];
    return getValue(jackpot);
  }
  return jackpots.reduce((acc, _ref4) => {
    let [product, jackpot] = _ref4;
    return Object.assign(acc, {
      [product]: getValue(jackpot)
    });
  }, {});
}
Object.entries(jackpotApi).forEach(_ref5 => {
  let [key, value] = _ref5;
  svs.numbergames.draws.jackpotApi[key] = products => formatJackpots(drawsSingleton.findJackpot(products), value, products);
  svs.numbergames.draws.asyncJackpotApi[key] = async products => formatJackpots(await drawsSingleton.getJackpot(products), value, products);
});

 })(window);